
import SET_GLOBAL_PUSHER_INSTANCE from 'Redux/types/utilitiesTypes';


const setGlobalPusherInstance = (pusherInstance) => ({
  type: SET_GLOBAL_PUSHER_INSTANCE,
  pusher: pusherInstance,
});

export default (pusherInstance) => (dispatch) => dispatch(setGlobalPusherInstance(pusherInstance));
